<template>
  <b-modal
    v-model="modalShow"
    id="playVideoFrame"
    size="sm"
    class="h-50"
    centered
    hide-footer
  >
    <video
      loop
      controls
      controlsList="nodownload"
      class="w-100 mt-n4"
      oncontextmenu="return false;"
      :poster="poster"
    >
      <source type="video/mp4" :src="src" />
      <p>Your browser doesn't support HTML5 video.</p>
    </video>
  </b-modal>
</template>

<script>
export default {
  name: 'PlayVideoModal',
  props: ['src', 'poster', 'modal'],
  data() {
    return {
      modalShow: false,
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.modal ? (this.modalShow = true) : ''
    })
  },
}
</script>

<style scoped></style>
